import React, { FC, useCallback, useContext, useRef, useState, Fragment, useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import { useDeterminedDirection } from "../../selectors/useDeterminedDirection";
import { useMergedOptions } from "../../selectors/useMergedOptions";
import DruidWebchatContext, { DruidWebchatContextType, WebChatHeaderOptions } from "../../WebChatContext";
import { DruidOptionsContainer } from "./DruidOptionsContainer";
import { DruidMinimizeSelector } from "./DruidMinimizeSelector";

import { DruidReloadSelector } from "./DruidReloadSelector";
import { DruidResetSelector } from "./DruidResetSelector";

import IconButton from 'botframework-webchat-component/lib/SendBox/IconButton';

import * as bsIcons from 'react-icons/bs';
import * as faIcons from 'react-icons/fa';

import classNames from "classnames";
import Button from "react-bootstrap/Button";
import Collapse from "react-bootstrap/Collapse";
import { useWebChatRefsContext } from "../../hooks/useWebChatRefsContext";
import useDruidLocalize from "../../hooks/useDruidLocalize";


export const DruidCustomButton: FC = () => {
    const [druidWebChatState, druidWebChatDispatch, ,] = useContext<DruidWebchatContextType>(DruidWebchatContext);
    const { setHeaderRef } = useWebChatRefsContext();



    const { disabled, UI: { v2_customButton_toggled_icon = "", v2_customButton_off_icon = "", v2_custom_button_initial_toggled = undefined, headerFontSize } = {},
        styleOptions: { } = {}
    } = useMergedOptions();

    const [toggled, setToggled] = useState(v2_custom_button_initial_toggled);

    const SwitchIcon = useMemo(() => (toggled ?
        bsIcons[v2_customButton_toggled_icon] || faIcons[v2_customButton_toggled_icon] || faIcons["FaSignOutAlt"] :
        (bsIcons[v2_customButton_off_icon] || faIcons[v2_customButton_off_icon]) || faIcons["FaSignInAlt"])
        , [toggled]);
    const handleCustomButtonSwitchClick = useCallback((e) => {
        e.stopPropagation();
        const newToggledValue = !toggled;
        setToggled(newToggledValue);
        druidWebChatDispatch({
            type: 'SET_CUSTOM_BUTTON_TOGGLE',
            payload: newToggledValue
        });
    }, [druidWebChatDispatch, toggled, setToggled]);

    return (<>
        {
            v2_custom_button_initial_toggled !== undefined && <IconButton
                alt={toggled ? "Logout" : "Login"}
                className={classNames('druid__webchat__header-button', 'druid__webchat__header-fadeIn')}
                disabled={disabled}
                onClick={handleCustomButtonSwitchClick}
            >
                {SwitchIcon && <SwitchIcon size={headerFontSize}></SwitchIcon>}
            </IconButton>
        }
    </>);
};